import React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { InputNumber } from 'primereact/inputnumber';

const SalaryDialog = ({
  visible,
  onHide,
  selectedEmployee,
  salaryForm,
  setSalaryForm,
  handleProcessSalarySubmit
}) => {
  const footer = (
    <div>
      <Button label="Cancel" icon="pi pi-times" onClick={onHide} className="p-button-text" />
      <Button label="Process Salary" icon="pi pi-check" onClick={handleProcessSalarySubmit} className="p-button-success" />
    </div>
  );

  return (
    <Dialog header="Process Salary" visible={visible} onHide={onHide} style={{ width: '600px' }} footer={footer}>
      {selectedEmployee && (
        <div className="space-y-4">
          <div className="bg-gray-50 p-4 rounded-lg">
            <h4 className="font-semibold">{selectedEmployee.firstName} {selectedEmployee.lastName}</h4>
            <p className="text-gray-600">{selectedEmployee.id} - {selectedEmployee.departmentName}</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Month *</label>
              <Calendar value={salaryForm.month} onChange={(e) => setSalaryForm({ ...salaryForm, month: e.value })} view="month" dateFormat="mm/yy" showIcon className="w-full" />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Basic Salary *</label>
              <InputNumber value={salaryForm.basicSalary} onValueChange={(e) => setSalaryForm({ ...salaryForm, basicSalary: e.value })} className="w-full" prefix="₹" />
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Allowances</label>
              <InputNumber value={salaryForm.allowances} onValueChange={(e) => setSalaryForm({ ...salaryForm, allowances: e.value })} className="w-full" prefix="₹" />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Deductions</label>
              <InputNumber value={salaryForm.deductions} onValueChange={(e) => setSalaryForm({ ...salaryForm, deductions: e.value })} className="w-full" prefix="₹" />
            </div>
          </div>

          <div className="bg-blue-50 p-4 rounded-lg">
            <div className="flex justify-between items-center">
              <span className="font-semibold">Total Salary:</span>
              <span className="text-xl font-bold text-blue-600">₹{((salaryForm.basicSalary || 0) + (salaryForm.allowances || 0) + (salaryForm.bonus || 0) - (salaryForm.deductions || 0)).toLocaleString()}</span>
            </div>
          </div>
        </div>
      )}
    </Dialog>
  );
};

export default SalaryDialog;
